module.exports = __webpack_public_path__ + "static/036.thumb-fbce142ca5701b10886e43fe4e3783a3.jpg";